const defaultReducer = (state) => state;

export const generateReducers = (mapTypeToReducer) => (
  state,
  { type, payload }
) => {
  const { [type]: reducer = defaultReducer } = mapTypeToReducer;
  return reducer(state, payload);
};
